<template>
  <div class="research_group_container" v-if="researchGroupCharacter === 'leader'">
    <div class="hd research-background-color">
      <span class="icon icon-left navshare" @click="goBack" v-if="!isWapp"></span>
      <span class="header_title">成员信息</span>
    </div>
    <div class="box " v-if="memberDetail && memberDetail.memberName">
      <div class="main">
        <div class="outer_3" >
          <div class="outer_attr">
            <div class="group">
              <span class="attr_name">姓名</span>
              <span class="attr">{{memberDetail.memberName}}</span>
            </div>
            <div class="container"><div class="empty" /></div>
          </div>
          <div class="outer_attr">
            <div class="group">
              <span class="attr_name">手机</span>
              <span class="attr">{{memberDetail.mobile}}</span>
            </div>
            <div class="container"><div class="empty" /></div>
          </div>
          <div class="outer_attr">
            <div class="group">
              <span class="attr_name">邮箱</span>
              <span class="attr">{{memberDetail.email}}</span>
            </div>
            <div class="container"><div class="empty" /></div>
          </div>
          <div class="outer_attr">
            <div class="group">
              <span class="attr_name">单位</span>
              <span class="attr">{{memberDetail.firstLevelEnterpriseName}}</span>
            </div>
            <div class="container"><div class="empty" /></div>
          </div>
<!--          <div class="outer_attr" v-if="memberDetail.firstLevelEnterpriseName.includes('医院')">-->
<!--            <div class="group">-->
<!--              <span class="attr_name">科室</span>-->
<!--              <span class="attr">{{memberDetail.secondLevelEnterpriseName}}</span>-->
<!--            </div>-->
<!--            <div class="container"><div class="empty" /></div>-->
<!--          </div>-->
          <div class="outer_attr">
            <div class="group">
              <span class="attr_name">加入日期</span>
              <span class="attr">{{memberDetail.createDT.split(" ")[0]}}</span>
            </div>
            <div class="container"><div class="empty" /></div>
          </div>
<!--          <div class="outer_attr">-->
<!--            <div class="group">-->
<!--              <span class="attr_name">审批原则</span>-->
<!--              <span class="attr">{{researchGroupApproveTypeDictionary[memberDetail.approveType]}}</span>-->
<!--            </div>-->
<!--            <div class="container"><div class="empty" /></div> -->
<!--          </div> -->
<!--          <div class="outer_attr" v-if="memberDetail.approveType === approveTypeThreshold">-->
<!--            <div class="group">-->
<!--              <span class="attr_name">审批限额</span>-->
<!--              <span class="attr">¥{{splitMoney(memberDetail.approveThreshold)}}</span>-->
<!--            </div>-->
<!--            <div class="container"><div class="empty" /></div> -->
<!--          </div> -->
        </div>
      </div>
      <div class="box_2">
        <div class="main" v-if="memberDetail && memberDetail.memberName">
          <div class="outer_3" >
<!--            <div class="outer_attr">-->
<!--              <div class="group">-->
<!--                <span class="attr_name">开启审批</span>-->
<!--                <span class="attr" ><label class="label-switch">-->
<!--                          <input id ="express" type="checkbox" v-model="startChooseBox" @change="changeapprove">-->
<!--                          <div class="checkbox" style="background-color: #5878fa;"></div>-->
<!--                        </label></span>-->
<!--              </div>-->
<!--              <div class="container"><div class="empty" /></div>-->
<!--            </div>-->
            <div class="outer_attr">
              <div class="group">
                <span class="attr_name">审批原则</span>
                <div class="wrap_approvetype" @click="toggleShowChooseBox(0)">
                  <span class="attr" v-if="approve.approveType === undefined" style="color: #FE654D;">请设置审批原则</span>
                  <span class="attr" v-if="approve.approveType === approveTypeNone" style="color: #60d837;">{{researchGroupApproveTypeDictionary[approve.approveType]}}</span>
                  <span class="attr" v-if="approve.approveType === approveTypeAll" style="color: #ff9400;">{{researchGroupApproveTypeDictionary[approve.approveType]}}</span>
                  <span class="attr" v-if="approve.approveType === approveTypeThreshold" style="color: #ff9400;">{{researchGroupApproveTypeDictionary[approve.approveType]}}</span>
                  <svg t="1583809028111" class="liveiconput" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1461" width="200" height="200"><path d="M279.937024 896.052224L743.875584 537.604096c0 0 25.778176-25.55392 0-51.207168-41.105408-40.80640001-442.91072-358.449152-463.93753599-358.449152-25.35424 25.201664 0 51.207168-1e-8 51.207168L692.31616 512l-412.379136 332.845056C279.937024 844.845056 254.582784 870.85056 279.937024 896.052224z" fill="#929292" p-id="1462"></path></svg>
                </div>
              </div>
              <div class="container"><div class="empty" /></div>
            </div>

            <div class="outer_attr" v-if="approve.approveType === approveTypeThreshold" >
              <div class="group">
                <span class="attr_name">单笔订单限额</span>
                <div class="wrap_approvetype" @click="toggleShowChooseBox(1)">
                  <span class="attr" v-if="approve.approveThreshold ===undefined" style="color: #FE654D;">请设置审批限额</span>
                  <span class="attr unlimitedAmount" v-else-if="approve.approveThreshold ===''">无限额</span>
                  <span v-else class="price">¥{{approve.approveThreshold}}</span>
                  <svg t="1583809028111" class="liveiconput" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1461" width="200" height="200"><path d="M279.937024 896.052224L743.875584 537.604096c0 0 25.778176-25.55392 0-51.207168-41.105408-40.80640001-442.91072-358.449152-463.93753599-358.449152-25.35424 25.201664 0 51.207168-1e-8 51.207168L692.31616 512l-412.379136 332.845056C279.937024 844.845056 254.582784 870.85056 279.937024 896.052224z" fill="#929292" p-id="1462"></path></svg>

                </div>
              </div>
              <div class="container"><div class="empty" /></div>
            </div>
            <div class="outer_attr" v-if="approve.approveType === approveTypeThreshold ">
              <div class="group">
                <span class="attr_name">单月累积限额</span>
                <div class="wrap_approvetype" @click="toggleShowChooseBox(2)">
                  <span class="attr" v-if=" approve.monthlyLimit === undefined" style="color: #FE654D;">请设置审批限额</span>
                  <span class="attr unlimitedAmount" v-else-if="approve.monthlyLimit ===''" >无限额</span>
                  <span v-else class="price">¥{{approve.monthlyLimit}}</span>
                  <svg t="1583809028111" class="liveiconput" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1461" width="200" height="200"><path d="M279.937024 896.052224L743.875584 537.604096c0 0 25.778176-25.55392 0-51.207168-41.105408-40.80640001-442.91072-358.449152-463.93753599-358.449152-25.35424 25.201664 0 51.207168-1e-8 51.207168L692.31616 512l-412.379136 332.845056C279.937024 844.845056 254.582784 870.85056 279.937024 896.052224z" fill="#929292" p-id="1462"></path></svg>
                </div>
              </div>
              <div class="container"><div class="empty" /></div>
            </div>
          </div>

        </div>
<!--                <div class="submain" v-if="approve.approveType && approve.approveType === approveTypeNone">-->
<!--              启用此选项后，该课题组成员在商城下单后需要审批人进行审批。-->
<!--              </div>-->
<!--        <div  class="submain" v-else-if=" approve.approveType && approve.approveType === approveTypeAll">-->
<!--      该课题组成员所有的订单均需要审批人进行审批。-->
<!--      </div >-->
<!--        <div  class="submain" v-else-if=" approve.approveType && approve.approveType === approveTypeThreshold">-->
<!--      启用此选项后，该课题组成员在商城下单后需要审批人进行审批。-->
<!--      </div >-->

      </div>
      <div class="ft" @click="checkMember()" v-if="type === emkt.RESEARCH_MEMBER_OP.add"><span class="tag">删除成员</span></div>
      <div class="ft submitAddMember" @click="submitAddMember()" v-if="type === emkt.RESEARCH_MEMBER_OP.approval"><span class="tag">确认添加</span></div>
<!--      <div class="ft">-->
<!--        <div class="col1" @click="checkMember()"><span class="tag">删除成员</span></div>-->
<!--        <div class="col2 research-background-color" @click="toggleShowChooseBox()"><span class="tag_2">审批原则设置</span></div>-->
<!--      </div>-->

    </div>

    <ChooseApproveType1 :memberDetail="memberDetail"   v-if="showChooseApproveType "    @updateMemberApproveType="saveApproveType"  :setApproveType="setallApproveType"  @toggleShow="toggleShowChooseBox(0)" />
    <ChooseApproveType2 :memberDetail="memberDetail"  v-if="showChooSinglestrokeApproveType "  @updateMemberApproveType="saveApproveType" :setApproveType="setSinglestrokeApproveType"  @toggleShow="toggleShowChooseBox(1)" />
    <ChooseApproveType2 :memberDetail="memberDetail"  v-if="showChooSinglemouthApproveType "    @updateMemberApproveType="saveApproveType"  :setApproveType="setmouthApproveType"  @toggleShow="toggleShowChooseBox(2)" />
<!--    <ChooseApproveType :memberDetail="memberDetail" v-if="showChooseApproveType" @updateMemberApproveType="saveMember" @toggleShow="toggleShowChooseBox" />-->
    <ResearchGroupRemindBox :remindParams="remindParams" v-if="showResearchGroupRemindBox" @toggleShow="toggleResearchGroupRemindBox" @confirm="deleteMember"/>
  </div>
</template>
<script>
import {mapGetters, mapState, mapMutations} from 'vuex'
import EMKT from '../../../../emkt'
import $ from 'jquery'
import ChooseApproveType1 from './../researchGroupComponents/ChooseApproveType1'
import ChooseApproveType2 from './../researchGroupComponents/ChooseApproveType2'
import ResearchGroupRemindBox from './../researchGroupComponents/ResearchGroupRemindBox'
export default {
  data () {
    return {
      researchGroupApproveTypeDictionary: EMKT.researchGroupApproveTypeDictionary,
      memberIndex: this.$route.query.memberIndex,
      approveTypeThreshold: EMKT.CONSTANT_APPROVETYPE_THRESHOLD,
      showChooseApproveType: false,
      showResearchGroupRemindBox: false,
      remindParams: {
        firstline: '该操作不可撤销',
        secondline: '确认删除该课题组成员？',
        singleOrDouble: 2
      },
      type: this.$route.query.type || EMKT.RESEARCH_MEMBER_OP.add,
      showChooSinglestrokeApproveType: false,
      showChooSinglemouthApproveType: false,
      setSinglestrokeApproveType: EMKT.CONSTANT_SET_SINGLESTORKE_APPROVETYPE,
      setmouthApproveType: EMKT.CONSTANT_SET_MOUNTH_APPROVETYPE,
      setallApproveType: EMKT.CONSTANT_ALL_APPROVETYPE,
      approveTypeNone: EMKT.CONSTANT_APPROVETYPE_NONE,
      approveTypeAll: EMKT.CONSTANT_APPROVETYPE_ALL,
      // startChooseBox: true,
      approve: {},
      isWapp: EMKT.isWapp
    }
  },
  created () {
    this.fetchData()
  },
  computed: {
    ...mapState([
      'researchGroupMemberMap', 'researchApprovalGroupMember'
    ]),
    ...mapGetters([
      'displayChosenResearchGroup', 'researchGroupCharacter'
    ]),
    memberDetail () {
      if (this.type === EMKT.RESEARCH_MEMBER_OP.add) {
        if (!this.displayChosenResearchGroup || JSON.stringify(this.displayChosenResearchGroup) === '{}') return {}
        if (!this.researchGroupMemberMap || JSON.stringify(this.researchGroupMemberMap) === '{}') return {}
        const researchGroupNo = this.displayChosenResearchGroup.researchGroupNo
        console.log((this.researchGroupMemberMap[researchGroupNo][this.memberIndex]))
        return this.researchGroupMemberMap[researchGroupNo][this.memberIndex]
      } else {
        return this.researchApprovalGroupMember
      }
    }
  },
  components: {
    ChooseApproveType1, ResearchGroupRemindBox, ChooseApproveType2
  },
  methods: {
    ...mapMutations([
      'UPDATE_RESEARCHGROUP_MEMBER_MAP', 'UPDATE_RESEARCHGROUPAPPROVALMEMBER_SET'
    ]),
    goBack () {
      this.$router.go(-1)
    },
    // changeapprove () {
    //       // this.memberDetail.approveType !== EMKT.CONSTANT_APPROVETYPE_NONE ? this.startChooseBox = true : false
    //   this.startChooseBox === false ? this.approve.approveType = this.approveTypeNone : this.approve.approveType = undefined
    // },
    checkMember () {
      const deletedMember = this.memberDetail
      const leaderNo = this.displayChosenResearchGroup.leaderNo
      const approverNo = this.displayChosenResearchGroup.approverNo
      const accountCustomerNo = this.displayChosenResearchGroup.accountCustomerNo
      if (leaderNo === deletedMember.memberNo) {
        $.toast('删除组长请联系业务员')
        return
      }
      if (approverNo === deletedMember.memberNo) {
        $.toast('删除前请先移除审批人身份')
        return
      }
      if (accountCustomerNo === deletedMember.memberNo) {
        $.toast('删除前请先移除对账联系人身份')
        return
      }
      this.toggleResearchGroupRemindBox()
    },
    deleteMember () {
      // 删除成员接口, 将课题组的一级客户和二级客户信息传到后台
      const waitDeleteMember = {...this.memberDetail}
      waitDeleteMember.firstLevelEnterpriseNo = this.displayChosenResearchGroup.firstLevelEnterpriseNo
      waitDeleteMember.firstLevelEnterpriseName = this.displayChosenResearchGroup.firstLevelEnterpriseName
      waitDeleteMember.secondLevelEnterpriseNo = this.displayChosenResearchGroup.secondLevelEnterpriseNo
      waitDeleteMember.secondLevelEnterpriseName = this.displayChosenResearchGroup.secondLevelEnterpriseName
      this.gcapi('deleteResearchGroupMember', waitDeleteMember).then(res => {
        if (res && res.body.code === 1) $.toast('信息同步失败，请联系业务员删除成员')
      })
      const newMemberMap = {...this.researchGroupMemberMap}
      newMemberMap[this.memberDetail.researchGroupNo].splice(this.memberIndex, 1)
      this.UPDATE_RESEARCHGROUP_MEMBER_MAP(newMemberMap)
      this.goBack()
    },
    toggleShowChooseBox (data) {
      console.log(data)
      switch (data) {
        case 0: this.showChooseApproveType = !this.showChooseApproveType
          break
        case 2: this.showChooSinglemouthApproveType = !this.showChooSinglemouthApproveType
          break
        case 1: this.showChooSinglestrokeApproveType = !this.showChooSinglestrokeApproveType
      }
    },
    saveMember (approve) {
      console.log('updateMemberApproveType', approve)
      if (approve.approveType === undefined) {
        return
      }
      console.log(this.approve)
      const memberToUpdate = {...this.memberDetail}
      memberToUpdate.approveType = approve.approveType
      if (approve.approveType === EMKT.CONSTANT_APPROVETYPE_THRESHOLD) {
        memberToUpdate.approveThreshold = approve.approveThreshold === '' ? null : approve.approveThreshold
        memberToUpdate.monthlyLimit = approve.monthlyLimit === '' ? null : approve.monthlyLimit
      } else {
        memberToUpdate.approveThreshold = null
        memberToUpdate.monthlyLimit = null
      }
      console.log('memberToUpdate', memberToUpdate)
      if (this.type === EMKT.RESEARCH_MEMBER_OP.add) {
        this.$weui.loading('保存中')
        // 保存到数据库
        this.gcapi('saveOrUpdateResearchGroupMember', memberToUpdate).then(res => {
          this.$weui.loading().hide()
          if (res && res.body.result) {
            const newMemberMap = {...this.researchGroupMemberMap}
            newMemberMap[memberToUpdate.researchGroupNo][this.memberIndex] = res.body.result
            this.UPDATE_RESEARCHGROUP_MEMBER_MAP(newMemberMap)
            this.$weui.toast('保存成功')
          } else {
            this.$weui.toast('保存失败')
          }
        })
      } else {
        this.UPDATE_RESEARCHGROUPAPPROVALMEMBER_SET(memberToUpdate)
        console.log(memberToUpdate)
      }
    },
    splitMoney (moneyNumber) {
      if (moneyNumber === undefined) {
        return ''
      }
      return String(moneyNumber).replace(/\B(?=(?:\d{3})+\b)/g, ',')
    },
    toggleResearchGroupRemindBox () {
      this.showResearchGroupRemindBox = !this.showResearchGroupRemindBox
    },
    fetchData () {
      this.approve.approveType = this.memberDetail.approveType
      this.approve.approveThreshold = this.memberDetail.approveThreshold === undefined ? '' : this.memberDetail.approveThreshold
      this.approve.monthlyLimit = this.memberDetail.monthlyLimit === undefined ? '' : this.memberDetail.monthlyLimit
      console.log(this.memberDetail.approveType !== EMKT.CONSTANT_APPROVETYPE_NONE)
    },
    saveApproveType (approve, setApproveType) {
      this.approve.approveType === approve.approveType
      setApproveType === this.setallApproveType ? this.approve = approve : (setApproveType === this.setSinglestrokeApproveType ? this.approve.approveThreshold = approve.approveThreshold : this.approve.monthlyLimit = approve.monthlyLimit)
      if (this.checkApproval()) {
        this.saveMember(this.approve)
      }
      // if (this.approve.approveType === this.approveTypeThreshold) {
      //   if (this.approve.approveThreshold === '' && this.approve.monthlyLimit === '') {
      //     $.toast('单笔订单限额和单月累积限额不可同时为无限额！')
      //     return
      //   } else if (this.approve.approveThreshold === undefined) {
      //     return
      //   } else if (this.approve.monthlyLimit === undefined) {
      //     return
      //   } else {
      //     this.saveMember(this.approve)
      //   }
      // } else {
      //   this.saveMember(this.approve)
      // }
    },
    checkApproval () {
      if (this.approve.approveType === this.approveTypeThreshold) {
        if (this.approve.approveThreshold === '' && this.approve.monthlyLimit === '') {
          $.toast('单笔订单限额和单月累积限额不可同时为无限额！')
          return false
        } else if (this.approve.approveThreshold === undefined) {
          return false
        } else if (this.approve.monthlyLimit === undefined) {
          return false
        } else {
          return true
        }
      } else {
        return true
      }
    },
    submitAddMember () {
      const _this = this
      if (_this.approve.approveType === undefined) {
        $.toast('请设置审批规则！')
        return
      }
      if (_this.checkApproval()) {
        console.log(_this.memberDetail)
        const researchGroupNo = _this.displayChosenResearchGroup.researchGroupNo
        const params = { ..._this.memberDetail, researchGroupNo }
        _this.$weui.loading('保存中')
        _this.gcapi('approvalRequestAndSaveMember', params).then(res => {
          _this.$weui.loading().hide()
          const newMemberMap = {...this.researchGroupMemberMap}
          newMemberMap[params.researchGroupNo].push(res.body.result)
          this.UPDATE_RESEARCHGROUP_MEMBER_MAP(newMemberMap)
          _this.$router.push({name: 'ResearchMemberManagement'})
        })
      }
    }
  }
}
</script>
<style scoped>
.research_group_container {
  overflow-y:scroll;
  overflow-x:hidden;
  /*-webkit-overflow-scrolling:touch;*/
  height:100%;
  width: 100%;
}
.box {
  display: flex;
  position: absolute;
  align-items: center;
  flex-direction: column;
  background-color: #efeef3;
  width: 100vw;
  height: calc(100vh - 14vw);
  top: 14.93vw;
}
.hd {
  display: flex;
  position: fixed;
  top:0;
  left:0;
  align-items: center;
  flex-direction: row;
  /*background-color: #5878fa;*/
  width: 100vw;
  height: 14.93vw;
  z-index: 10;
  justify-content: center;
}


.navshare {
  position: absolute;
  left: 6.67vw;
  width: 10vw;
  height: 10vw;
  padding-top: 2vw;
  color:#ffffff;
}
.header_title {
  opacity: 1;
  /*margin-left: 29.33vw;*/
  max-width: 60.53vw;
  height: 5.87vw;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 5.87vw;
  white-space: nowrap;
  color: #ffffff;
  font-size: 4.27vw;
  font-weight: 400;
}

.main {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 6.67vw;
  width: 99.73vw;
}

.outer_3 {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: center;
  border-radius: 2.67vw;
  background-color: #ffffff;
  width: 86.67vw;
  padding: 2vw 0;
}

.outer_attr {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: center;
  background-color: #ffffff;
  width: 86.67vw;
  height:12.8vw;
}
.outer_3 .outer_attr:last-child .empty{
  width: 73.6vw;
  height: 0.53vw;
  border: 0;
}

.empty {
  border-top-width: 0.7px;
  border-top-style: solid;
  border-top-color: rgba(213, 213, 213, 1);
  width: 73.6vw;
  height: 0.53vw;
}

.group {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 3.47vw;
  padding-right: 6.4vw;
  padding-left: 6.67vw;
  width: 86.67vw;
  align-items: center;
}

.attr_name {
  opacity: 1;
  width: 7.47vw;
  height: 5.33vw;
  line-height: 5.33vw;
  white-space: nowrap;
  color: #424242;
  font-size: 3.73vw;
  font-weight: 500;
}

.attr {
  opacity: 1;
  height: 5.33vw;
  line-height: 5.33vw;
  white-space: nowrap;
  color: #929292;
  font-size: 3.73vw;
  font-weight: 400;
}

.container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 4vw;
  width: 86.4vw;
}

.col1 {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  border-radius: 2.67vw;
  background-color: #fe654d;
  width: 40vw;
  height: 13.33vw;
}

.tag {
  opacity: 1;
  margin-top: 1.07vw;
  max-width: 47.2vw;
  height: 5.33vw;
  overflow: hidden;
  text-align: center;
  text-overflow: ellipsis;
  line-height: 5.33vw;
  white-space: nowrap;
  color: #ffffff;
  font-size: 3.73vw;
  font-weight: 400;
}

.col2 {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  border-radius: 2.67vw;
  /*background-color: #5878fa;*/
  width: 40vw;
  height: 13.33vw;
}

.tag_2 {
  opacity: 1;
  max-width: 36.8vw;
  overflow: hidden;
  text-align: center;
  text-overflow: ellipsis;
  line-height: 5.33vw;
  white-space: nowrap;
  color: #ffffff;
  font-size: 3.73vw;
  font-weight: 400;
}
.submain {
  overflow: hidden;
  text-align: justify;
  text-overflow: ellipsis;
  line-height: 4vw;
  color: #929292;
  font-size: 2.6vw;
  font-weight: 400;
  margin-top: -0rem;
  margin-bottom: 0rem;
  width: 86.67vw;
  padding: 2vw 0;
  margin-left: 1rem;
}
.unlimitedAmount {
  opacity: 1;
  color: #60d837;
  font-size: 3.87vw;
  font-weight: 400;
}
.price{
  color: #ff9400;
  font-size: 3.87vw;
  font-weight: 400;
}
.liveiconput {
  margin-left: 1vw;
  width: 4.5vw;
  height: 4.5vw;
  margin-bottom: -.2rem;
}
 .ft {
   display: flex;
   align-items: center;
   flex-direction: row;
   width: 86.67vw;
   height: 13.33vw;
   margin-bottom: 10vw;
   margin-top: 6.67vw;
   justify-content: center;
   border-radius: 10px;
   background-color: #fe654d;
   flex-shrink: 0;
}
.submitAddMember {
  background-color: #5878FA;
}
</style>



// WEBPACK FOOTER //
// ResearchMemberDetail.vue?54fa5344